/* eslint-disable no-unused-vars */
import overlayScrollbars from 'overlayscrollbars/js/OverlayScrollbars';
// import './style.scss';

/**
 * Documentation #{@link => https://kingsora.github.io/OverlayScrollbars/#!documentation/options}
 * @param $scrollers
 * @param options
 */
export default function scrollBar ($scrollers, options = {}) {
	let defaults = {
		className: 'os-theme-dark',
		// className: 'os-theme-thin-dark',
		resize: 'none',
		sizeAutoCapable: true,
		clipAlways: true,
		normalizeRTL: true,
		paddingAbsolute: false,
		autoUpdate: true,
		autoUpdateInterval: 33,
		nativeScrollbarsOverlaid: {
			showNativeScrollbars: false,
			initialize: true
		},
		overflowBehavior: {
			x: 'scroll',
			y: 'scroll'
		},
		scrollbars: {
			visibility: 'auto',
			autoHide: 'never',
			autoHideDelay: 500,
			dragScrolling: true,
			clickScrolling: false,
			touchSupport: true
		},
		textarea: {
			dynWidth: false,
			dynHeight: false
		},
		callbacks: {
			onInitialized: null,
			onInitializationWithdrawn: null,
			onDestroyed: null,
			onScrollStart: null,
			onScroll: null,
			onScrollStop: null,
			onOverflowChanged: null,
			onOverflowAmountChanged: null,
			onDirectionChanged: null,
			onContentSizeChanged: null,
			onHostSizeChanged: null,
			onUpdated: null
		}
	};

	/**
	 * https://github.com/KingSora/OverlayScrollbars/issues/11#issuecomment-366057278
	 *
	 * При динамическом добавлении елемнтов в DOM дерево,
	 * необходим дополнительный блок-обертка между елементом на котором инициализируется скролл
	 * и элементом в который добавляется динамическое содержимое
	 *
	 * Пример можно увидеть в разметке блока site-search
	 *
	 * <div class="site-search__suggestion" data-scroller data-live-search="suggestion">
	 * 		<div class="site-search__os-fix-wrapper" data-live-search="suggestion-content">
	 * 			<div class="site-search__suggestion-section" data-live-search="suggestion-section">
	 * 				<div class="site-search__suggestion-title">__ss-title__</div>
	 * 				<ul class="site-search__suggestion-list">__ss-list__</ul>
	 * 			</div>
	 * 		</div>
	 * </div>
	 *
	 * на атрибуте data-scrolleк инициализируется кастомный скролл
	 * блок `data-live-search="suggestion-section"` вырезается из DOM дерева, наполянется данными в цикле
	 * и потом вставляется в блок `data-live-search="suggestion-content"`
	 */
	$scrollers.each((i, scroller) => {
		let $scroller = $(scroller);
		let inlineOptions = $scroller.data('scroller') || {};
		let params = $.extend(true, {}, defaults, options, inlineOptions);

		let osInstance = $scroller.overlayScrollbars(params).overlayScrollbars();

		$scroller.data('os-inst', osInstance);
	});
}



// WEBPACK FOOTER //
// ./_HTML/src/js/_modules/scrollBar/index.js